const lymphNode=[
    {
    label:"Site(s)",
    controlType:"checkbox group",
    options:["neck", "supraclavicular", "axillary", "groin"]
    },


    { label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }
]

export default lymphNode